import { render, staticRenderFns } from "./baseLayout.vue?vue&type=template&id=132051ff&scoped=true&"
import script from "./baseLayout.vue?vue&type=script&lang=js&"
export * from "./baseLayout.vue?vue&type=script&lang=js&"
import style0 from "./baseLayout.vue?vue&type=style&index=0&id=132051ff&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.10.1_cache-loader@4.1.0_css-loader@3.6.0_vue-template-compiler@2.6.14_webpack@4.46.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132051ff",
  null
  
)

export default component.exports